import { Pipe, PipeTransform } from '@angular/core';
import { formatCurrency, getCurrencySymbol } from '@angular/common';

type PhxCurrencyCodeType = 'USD';

@Pipe({ name: 'phxCurrency' })
export class PhxCurrencyPipe implements PipeTransform {
  private readonly format = '1.2-2';
  private readonly locale = 'en';

  /**
   * Formats the currency value and add specified country currency symbol.
   * 
   * @param {number | string | null} amount - value to be formatted.
   * @param {PhxCurrencyCodeType} [currencyCode='USD'] - The currency code of the country, whose currency symbol is to be added.
   * @remarks Format for currency will always be 1.2-2. locale will always be en.
   * @returns Formatted currency value.
   */
  public transform(
    amount: number | string | null,
    currencyCode: PhxCurrencyCodeType = 'USD',
  ): string {
    if (amount == null || amount === '') return;

    // Change 'wide to 'narrow' if we want to use $ instead of CA$. See https://angular.io/api/common/getCurrencySymbol
    const currency = getCurrencySymbol(currencyCode, 'narrow');
    return formatCurrency(+amount, this.locale, currency, currencyCode, this.format);
  }
}
